<template>
  <div class="cell" :class="{'divide-line': divide}" @click="$emit('click')">
    <div class="left" :style="{color: leftColor}">{{ leftText }}</div>
    <div class="middle" :style="{color: middleColor}" v-if="!!middleText">{{ middleText }}</div>
    <div :class="singLine ? 'single-line' : 'right'" :style="{color: rightColor}" v-if="!!rightText">{{ rightText }}</div>
    <div class="right-arr" >
      <i class="icon" v-show="rightArraw" :style="{color: rightArrowColor}" >&#xe601;</i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftText: {
      type: String,
      required: true
    },
    leftColor: {
      type: String,
      default: '#363636'
    },
    middleText: {
      type: String
    },
    middleColor: {
      type: String,
      default: '#888888'
    },
    rightText: {
      type: String
    },
    rightColor: {
      type: String,
      default: '#31c27c'
    },
    rightArrowColor: {
      type: String,
      default: '#A0A1A3'
    },
    divide: {
      type: Boolean,
      default: true
    },
    singLine: {
      type: Boolean,
      default: false
    },
    rightArraw: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'

.divide-line
  border-bottom 1px solid $divide-line-color

.cell
  height pt(95)
  display flex
  justify-content flex-start
  align-items center
  width 100%
  font-size $normal-font-size
  .left
    width 9em
    flex 0 1 auto
    text-align left
    single-line()
  .middle
    width 5em
    flex 0 1 auto
    text-align left
  .right
    flex 1 1 auto
    text-align right
    single-line()
  .single-line
    flex 1 1 auto
    text-align right
  .right-arr
    width  pt(20)
    display flex
    justify-content center
</style>




// WEBPACK FOOTER //
// item-cell.vue?3c5560d3